import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Eyes () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.eyesIcterus.name}
            options={[
              {
                label: 'No Icterus',
                value: 'No Icterus'
              },
              {
                label: 'Icterus',
                value: 'Icterus'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.eyesPerrlbANDanisocoria.name}
            options={[
              {
                label: 'PERRLB',
                value: 'PERRLB'
              },
              {
                label: 'Anisocoria',
                value: 'Anisocoria'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.eyesEomiANDnystagmus.name}
            options={[
              {
                label: 'EOMI',
                value: 'EOMI'
              },
              {
                label: 'Nystagmus',
                value: 'Nystagmus'
              }
            ]}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.eyesOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.eyesOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Eyes
